"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _alignCenter = _interopRequireDefault(require("./icons/align-center"));

var _alignJustify = _interopRequireDefault(require("./icons/align-justify"));

var _alignLeft = _interopRequireDefault(require("./icons/align-left"));

var _alignRight = _interopRequireDefault(require("./icons/align-right"));

var _attachment = _interopRequireDefault(require("./icons/attachment"));

var _audio = _interopRequireDefault(require("./icons/audio"));

var _authorship = _interopRequireDefault(require("./icons/authorship"));

var _background = _interopRequireDefault(require("./icons/background"));

var _blockquote = _interopRequireDefault(require("./icons/blockquote"));

var _bold = _interopRequireDefault(require("./icons/bold"));

var _clean = _interopRequireDefault(require("./icons/clean"));

var _code = _interopRequireDefault(require("./icons/code"));

var _codeBlock = _interopRequireDefault(require("./icons/code-block"));

var _color = _interopRequireDefault(require("./icons/color"));

var _comment = _interopRequireDefault(require("./icons/comment"));

var _directionLtr = _interopRequireDefault(require("./icons/direction-ltr"));

var _directionRtl = _interopRequireDefault(require("./icons/direction-rtl"));

var _dropdown = _interopRequireDefault(require("./icons/dropdown"));

var _emoji = _interopRequireDefault(require("./icons/emoji"));

var _embed = _interopRequireDefault(require("./icons/embed"));

var _floatCenter = _interopRequireDefault(require("./icons/float-center"));

var _floatFull = _interopRequireDefault(require("./icons/float-full"));

var _floatLeft = _interopRequireDefault(require("./icons/float-left"));

var _floatRight = _interopRequireDefault(require("./icons/float-right"));

var _font = _interopRequireDefault(require("./icons/font"));

var _formula = _interopRequireDefault(require("./icons/formula"));

var _hashtag = _interopRequireDefault(require("./icons/hashtag"));

var _horizontalRule = _interopRequireDefault(require("./icons/horizontal-rule"));

var _header = _interopRequireDefault(require("./icons/header-6"));

var _header2 = _interopRequireDefault(require("./icons/header-5"));

var _header3 = _interopRequireDefault(require("./icons/header-4"));

var _header4 = _interopRequireDefault(require("./icons/header-3"));

var _header5 = _interopRequireDefault(require("./icons/header-2"));

var _header6 = _interopRequireDefault(require("./icons/header"));

var _image = _interopRequireDefault(require("./icons/image"));

var _indent = _interopRequireDefault(require("./icons/indent"));

var _italic = _interopRequireDefault(require("./icons/italic"));

var _link = _interopRequireDefault(require("./icons/link"));

var _listBullet = _interopRequireDefault(require("./icons/list-bullet"));

var _listCheck = _interopRequireDefault(require("./icons/list-check"));

var _listOrdered = _interopRequireDefault(require("./icons/list-ordered"));

var _map = _interopRequireDefault(require("./icons/map"));

var _more = _interopRequireDefault(require("./icons/more"));

var _mention = _interopRequireDefault(require("./icons/mention"));

var _outdent = _interopRequireDefault(require("./icons/outdent"));

var _redo = _interopRequireDefault(require("./icons/redo"));

var _sizeDecrease = _interopRequireDefault(require("./icons/size-decrease"));

var _sizeIncrease = _interopRequireDefault(require("./icons/size-increase"));

var _size = _interopRequireDefault(require("./icons/size"));

var _spacing = _interopRequireDefault(require("./icons/spacing"));

var _speech = _interopRequireDefault(require("./icons/speech"));

var _strike = _interopRequireDefault(require("./icons/strike"));

var _subscript = _interopRequireDefault(require("./icons/subscript"));

var _superscript = _interopRequireDefault(require("./icons/superscript"));

var _tableBorderAll = _interopRequireDefault(require("./icons/table-border-all"));

var _tableBorderBottom = _interopRequireDefault(require("./icons/table-border-bottom"));

var _tableBorderLeft = _interopRequireDefault(require("./icons/table-border-left"));

var _tableBorderNone = _interopRequireDefault(require("./icons/table-border-none"));

var _tableBorderOutside = _interopRequireDefault(require("./icons/table-border-outside"));

var _tableBorderRight = _interopRequireDefault(require("./icons/table-border-right"));

var _tableBorderTop = _interopRequireDefault(require("./icons/table-border-top"));

var _tableDeleteCells = _interopRequireDefault(require("./icons/table-delete-cells"));

var _tableDeleteColumns = _interopRequireDefault(require("./icons/table-delete-columns"));

var _tableDeleteRows = _interopRequireDefault(require("./icons/table-delete-rows"));

var _tableInsertCells = _interopRequireDefault(require("./icons/table-insert-cells"));

var _tableInsertColumns = _interopRequireDefault(require("./icons/table-insert-columns"));

var _tableInsertRows = _interopRequireDefault(require("./icons/table-insert-rows"));

var _tableMergeCells = _interopRequireDefault(require("./icons/table-merge-cells"));

var _tableUnmergeCells = _interopRequireDefault(require("./icons/table-unmerge-cells"));

var _table = _interopRequireDefault(require("./icons/table"));

var _underline = _interopRequireDefault(require("./icons/underline"));

var _undo = _interopRequireDefault(require("./icons/undo"));

var _video = _interopRequireDefault(require("./icons/video"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = {
  AlignCenter: _alignCenter.default,
  AlignJustify: _alignJustify.default,
  AlignLeft: _alignLeft.default,
  AlignRight: _alignRight.default,
  Attachment: _attachment.default,
  Audio: _audio.default,
  Authorship: _authorship.default,
  Background: _background.default,
  Blockquote: _blockquote.default,
  Bold: _bold.default,
  Clean: _clean.default,
  Code: _code.default,
  CodeBlock: _codeBlock.default,
  Color: _color.default,
  Comment: _comment.default,
  DirectionLtr: _directionLtr.default,
  DirectionRtl: _directionRtl.default,
  Dropdown: _dropdown.default,
  Emoji: _emoji.default,
  Embed: _embed.default,
  FloatCenter: _floatCenter.default,
  FloatFull: _floatFull.default,
  FloatLeft: _floatLeft.default,
  FloatRight: _floatRight.default,
  Font: _font.default,
  Formula: _formula.default,
  Hashtag: _hashtag.default,
  HorizontalRule: _horizontalRule.default,
  Header6: _header.default,
  Header5: _header2.default,
  Header4: _header3.default,
  Header3: _header4.default,
  Header2: _header5.default,
  Header: _header6.default,
  Image: _image.default,
  Indent: _indent.default,
  Italic: _italic.default,
  Link: _link.default,
  ListBullet: _listBullet.default,
  ListCheck: _listCheck.default,
  ListOrdered: _listOrdered.default,
  Map: _map.default,
  More: _more.default,
  Mention: _mention.default,
  Outdent: _outdent.default,
  Redo: _redo.default,
  SizeDecrease: _sizeDecrease.default,
  SizeIncrease: _sizeIncrease.default,
  Size: _size.default,
  Spacing: _spacing.default,
  Speech: _speech.default,
  Strike: _strike.default,
  Subscript: _subscript.default,
  Superscript: _superscript.default,
  TableBorderAll: _tableBorderAll.default,
  TableBorderBottom: _tableBorderBottom.default,
  TableBorderLeft: _tableBorderLeft.default,
  TableBorderNone: _tableBorderNone.default,
  TableBorderOutside: _tableBorderOutside.default,
  TableBorderRight: _tableBorderRight.default,
  TableBorderTop: _tableBorderTop.default,
  TableDeleteCells: _tableDeleteCells.default,
  TableDeleteColumns: _tableDeleteColumns.default,
  TableDeleteRows: _tableDeleteRows.default,
  TableInsertCells: _tableInsertCells.default,
  TableInsertColumns: _tableInsertColumns.default,
  TableInsertRows: _tableInsertRows.default,
  TableMergeCells: _tableMergeCells.default,
  TableUnmergeCells: _tableUnmergeCells.default,
  Table: _table.default,
  Underline: _underline.default,
  Undo: _undo.default,
  Video: _video.default
};
exports.default = _default;